import { BindingCreator } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

export const BDO_NUMBER_FIELD_NAME = 'bdoNumber';
const BDO_NUMBER_MAX_LENGHT = 9;
// eslint-disable-next-line require-unicode-regexp
const BDO_NUMBER_PATTERN = /\d{9}/;

export type BdoNumberFormBeanPart = {
   [BDO_NUMBER_FIELD_NAME]: string | null;
};

type BdoNumberFieldProps = {
   readonly register: BindingCreator<BdoNumberFormBeanPart, typeof BDO_NUMBER_FIELD_NAME>;
};

export const BdoNumberField = (props: BdoNumberFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(BDO_NUMBER_FIELD_NAME, {
            minLength: {
               value: BDO_NUMBER_MAX_LENGHT,
               message: invoiceSharedComponentsTranslationKeys.bdoNumber.minLength,
            },
            maxLength: BDO_NUMBER_MAX_LENGHT,
            pattern: {
               value: new RegExp(BDO_NUMBER_PATTERN, 'u'),
               message: invoiceSharedComponentsTranslationKeys.bdoNumber.invalid,
            },
         })}
         testId={BDO_NUMBER_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.bdoNumber.label}
         placeholder={invoiceSharedComponentsTranslationKeys.bdoNumber.placeholder}
      />
   );
};
